import {
  DeleteOutlined,
  EditOutlined,
  FilePdfTwoTone,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import {
  cotizacionesStartLoad,
  cotizacionSetActive,
  cotizacionStartDelete,
  get_pdf_cotizacion,
} from "../../../actions/cotizacion";
import { showDeleteConfirm } from "../../../helpers/confirmModal";
import { open_file } from "../../../helpers/utils";
import { TableUi } from "../../ui/TableUi";
import {
  CurrencyColumn,
  DefaultTag,
  EnviadoTag,
  ErrorTag,
  MoreOptionsColumn,
} from "../../ui";
import { messageError } from "../../../helpers";
import { EstadoCotizacionConstants } from "../../../helpers/constants";

const keysMenuActions = {
  btn_editar: {
    key: "btn_editar",
    label: "Editar",
    icon: <EditOutlined />,
  },
  btn_eliminar: {
    key: "btn_eliminar",
    label: "Eliminar",
    icon: <DeleteOutlined />,
  },
  opt_pdf: {
    key: "reporte_pdf",
    label: "Reporte",
    icon: <FilePdfTwoTone twoToneColor="#FF4D4F" />,
    danger: true,
  },
};
const menuItems = (data) => [
  { ...keysMenuActions.btn_editar },
  { ...keysMenuActions.btn_eliminar },
  { ...keysMenuActions.opt_pdf },
];

const columns = (acciones) => [
  {
    title: "N°",
    dataIndex: "nro",
    key: "nro",
    render: (text, record, index) => <>{index + 1}</>,
  },
  {
    title: "Fecha Emisión",
    dataIndex: "fechaemision",
    key: "fechaemision",
  },
  {
    title: "Cotización",
    dataIndex: "numero",
    key: "numero",
    align: "center",
  },
  {
    title: "Cliente",
    dataIndex: ["cliente", "nombrecompleto"],
    key: "clientenombrecompleto",
  },
  {
    title: "SubTotal",
    dataIndex: "montosubtotal",
    key: "montosubtotal",
    align: "right",
    render: (text, record) => (
      <CurrencyColumn currency={text} moneda={record.moneda_nombre} />
    ),
  },
  {
    title: "IGV",
    dataIndex: "montoigvtotal",
    key: "montoigvtotal",
    align: "right",
    render: (text, record) => (
      <CurrencyColumn currency={text} moneda={record.moneda_nombre} />
    ),
  },
  {
    title: "Total",
    dataIndex: "montototal",
    key: "montototal",
    align: "right",
    render: (text, record) => (
      <CurrencyColumn currency={text} moneda={record.moneda_nombre} />
    ),
  },
  {
    title: "Estado",
    dataIndex: "estado_nombre",
    key: "estado_nombre",
    align: "center",
    render: (text, record) => {
      if (record?.estado === EstadoCotizacionConstants.REGISTRADO) {
        return <DefaultTag text={text} />;
      } else if (record?.estado === EstadoCotizacionConstants.ACEPTADO)
        return <EnviadoTag />;
      else if (record?.estado === EstadoCotizacionConstants.RECHAZADO)
        return <ErrorTag text={text} />;
    },
  },

  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    render: (text, record) => (
      <MoreOptionsColumn
        data={record}
        MenuItems={menuItems}
        handleMenuItemClick={acciones?.handleMenuItemClick}
      />
    ),
  },
];

export const CotizacionTable = ({
  cotizaciones,
  loading,
  paginator,
  handleOpenForm,
}) => {
  const dispatch = useDispatch();
  const handleEditar = (data) => {
    dispatch(cotizacionSetActive(data));
    handleOpenForm();
  };
  const handleEliminar = (data) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar la cotización seleccionada?",
      data.numero,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(cotizacionStartDelete(data));
        }
      },
    );
  };
  const handleReportePDF = async (data) => {
    const pdf = await get_pdf_cotizacion(data?.id);
    open_file(pdf, data?.numero);
  };
  const handleMenuItemClick = (e, record) => {
    try {
      if (e.key === keysMenuActions.btn_editar.key) {
        handleEditar(record);
      } else if (e.key === keysMenuActions.btn_eliminar.key) {
        handleEliminar(record);
      } else if (e.key === keysMenuActions.opt_pdf.key) {
        handleReportePDF(record);
      }
    } catch (errors) {
      messageError(errors);
    }
  };
  const handleLoadDataPagination = (page = 1, page_size = 10) => {
    let searchFormData = JSON.parse(localStorage.getItem("SearhFormTable"));
    searchFormData = { ...searchFormData, page, page_size };
    const paginates = Math.floor(paginator?.count / page_size);
    if (paginates >= 1) {
      dispatch(cotizacionesStartLoad(searchFormData));
    }
  };
  return (
    <TableUi
      columns={columns({
        handleEditar,
        handleEliminar,
        handleReportePDF,
        handleMenuItemClick,
      })}
      dataSource={cotizaciones}
      loading={loading}
      rowKey="id"
      size="small"
      pagination={{
        align: "start",
        showSizeChanger: true,
        total: paginator?.count,
        onChange: (page, page_size) =>
          handleLoadDataPagination(page, page_size),
        showTotal: (total) => `Total ${total} items`,
      }}
    />
  );
};
